import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 16px;
`;

export const Wrapper = styled.div`
  display: ${props => props.loading || !props.hasConfigs.length ? 'none' : 'flex'};
  flex-direction: column;
  justify-content: space-between;

  .evolutiveSelectFilter {
    box-sizing: border-box;
    padding: 0 10px;
    min-width: 300px;
    max-width: 400px;
    height: 29px;

    background-color: ${({theme}) => theme.colors.component};
    border: 1px solid ${({theme}) => theme.colors.secondary}; 
    border-radius: 8px;
    
    display: flex;
    align-items: center;
    
    .seletor-head  {
      height: auto;
      .title {
        color: ${({theme}) => theme.colors.secondary};
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;

        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .seletor-body {
      top: 22px;
      background-color: ${({theme}) => theme.colors.component};
      border: 1px solid ${({theme}) => theme.colors.secondary}; 
      border-top: none;
    }
  }
`;

export const Text = styled.p`
  margin: 0 0 8px 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${({theme}) => theme.colors.text.placeholder};
`;

export const MainQuestion = styled.p`
  margin: 0;
  padding-right: 18px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${({theme}) => theme.colors.secondary};

  max-width: 305px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const MainQuestionWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 2px 4px 0;
`;